/**
 * Loyalty card identity (owner decision 14.10.2026). The program itself (cashback, Wallet passes)
 * comes later; for now the kiosk can already identify a customer by the QR on the card.
 * The QR holds only a random card code — never a phone number or a name.
 */
export const LOYALTY_CARD_CODE = /^360F-[A-Z0-9]{8,32}$/;
export function isLoyaltyCardCode(value) {
    return LOYALTY_CARD_CODE.test(value);
}
//# sourceMappingURL=loyalty.js.map